import { render, staticRenderFns } from "./DashBoardReviewPage.vue?vue&type=template&id=69af8c73&scoped=true"
import script from "./DashBoardReviewPage.vue?vue&type=script&lang=js"
export * from "./DashBoardReviewPage.vue?vue&type=script&lang=js"
import style0 from "./DashBoardReviewPage.vue?vue&type=style&index=0&id=69af8c73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69af8c73",
  null
  
)

export default component.exports